import { render, staticRenderFns } from "./ProjetoNovo.vue?vue&type=template&id=513e916c"
import script from "./ProjetoNovo.vue?vue&type=script&lang=js"
export * from "./ProjetoNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports